// @flow
import defaultState from '../defaultState';
import type {
  InsightSet as State,
  InsightSetActions as Action
} from '../types';

const defaultCurrentInsightSet = defaultState.currentInsightSet;

export default function currentInsightSet(
  state: State = defaultCurrentInsightSet,
  action: Action
) {
  switch (action.type) {
    case 'UPDATE_CURRENT_INSIGHTSET':
      return {
        ...defaultCurrentInsightSet,
        ...action.insightSet.insightSet,
        settings: { ...action.insightSet.settings }
      };

    case 'UPDATE_CURRENT_INSIGHTSET_SETTINGS':
      return {
        ...state,
        settings: action.settings
      };

    case 'UPDATE_CURRENT_INSIGHTSET_ALLOCATED_INSIGHTS':
      return {
        ...state,
        insights: {
          allocated: action.insights,
          unallocated: state.insights.unallocated
        }
      };

    case 'UPDATE_CURRENT_INSIGHTSET_UNALLOCATED_INSIGHTS':
      return {
        ...state,
        insights: {
          unallocated: action.insights,
          allocated: state.insights.allocated
        }
      };

    case 'UPDATE_CURRENT_INSIGHTSET_ALLOCATED_INDUSTRIES':
      return {
        ...state,
        industries: {
          ...state.industries,
          allocated: action.industries
        }
      };

    case 'UPDATE_CURRENT_INSIGHTSET_UNALLOCATED_INDUSTRIES':
      return {
        ...state,
        industries: {
          ...state.industries,
          unallocated: action.industries
        }
      };

    case 'UPDATE_CURRENT_INSIGHTSET_ALLOCATED_ORGANISATIONS':
      return {
        ...state,
        organisations: {
          ...state.organisations,
          allocated: action.organisations
        }
      };

    case 'UPDATE_CURRENT_INSIGHTSET_UNALLOCATED_ORGANISATIONS':
      return {
        ...state,
        organisations: {
          ...state.organisations,
          unallocated: action.organisations
        }
      };

    case 'CLEAR_CURRENT_INSIGHTSET':
      return defaultCurrentInsightSet;

    case 'LOGOUT':
      return defaultCurrentInsightSet;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/currentInsightSet.js